import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/pages/HomePage";
import BuildPage from "./components/pages/BuildPage";
import DeliveryPage from "./components/pages/DeliveryPage";
import AboutPage from "./components/pages/AboutPage";
import ContactPage from "./components/pages/ContactPage";

// Admin pages
import AdminLogin from "./components/admin/AdminLogin";
import AdminOrders from "./components/admin/AdminOrders";
import AdminOrderDetail from "./components/admin/AdminOrderDetail";
import AdminGallery from "./components/admin/AdminGallery";

function App() {
  useEffect(() => {
    // Set page title
    document.title = "FlowBerry | Premium Roses Delivery in Los Angeles";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/build" element={<BuildPage />} />
          <Route path="/delivery" element={<DeliveryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/orders/:orderId" element={<AdminOrderDetail />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
